'use client';
import React, { useState } from 'react';

export default function NewsletterSection() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
    }
  };

  return (
    <section className="bg-[#0F0F0F] py-20 relative overflow-hidden border-t border-[#CC0000]/20">
      <div
        className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, rgb(204, 0, 0) 1px, transparent 0px)',
          backgroundSize: '40px 40px',
        }}
      />
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 relative">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-5">
              <span className="font-mono text-xs text-[#CC0000] tracking-[0.2em]">[ 08 ]</span>
              <div className="h-[1px] w-12 bg-[#CC0000]" />
              <span className="text-[#CC0000] text-xs font-bold uppercase tracking-[0.2em] font-heading">Newsletter</span>
            </div>
            <h2 className="text-4xl sm:text-5xl font-extrabold text-white font-heading leading-[1.05] tracking-tight mb-5">
              Stay <span className="text-[#CC0000]">informed</span>
            </h2>
            <p className="text-gray-400 max-w-xl leading-relaxed">
              Subscribe to our newsletter for the latest updates on Uganda&apos;s petroleum sector, project milestones, and procurement opportunities.
            </p>
          </div>
          <div className="lg:col-span-6">
            {submitted ? (
              <div className="bg-[#CC0000]/10 border border-[#CC0000]/30 rounded-sm p-8 text-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-[#CC0000] mx-auto mb-4" aria-hidden="true">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <path d="m9 11 3 3L22 4" />
                </svg>
                <p className="text-white font-semibold text-lg">Thank you for subscribing!</p>
                <p className="text-gray-400 text-sm mt-2">You&apos;ll receive our latest updates soon.</p>
              </div>
            ) : (
              <form className="space-y-3" onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <input
                    type="text"
                    placeholder="Your Name (Optional)"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="bg-white/5 border border-white/10 rounded-sm px-4 py-3.5 text-white placeholder:text-gray-500 focus:outline-none focus:border-[#CC0000] transition-colors"
                  />
                  <input
                    type="email"
                    required
                    placeholder="Email Address *"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="bg-white/5 border border-white/10 rounded-sm px-4 py-3.5 text-white placeholder:text-gray-500 focus:outline-none focus:border-[#CC0000] transition-colors"
                  />
                </div>
                <button
                  type="submit"
                  className="w-full inline-flex items-center justify-center gap-2 bg-[#CC0000] text-white pl-5 pr-2 py-3 rounded-sm font-semibold hover:bg-[#AA0000] transition-colors group"
                >
                  Subscribe
                  <span className="bg-white/15 group-hover:bg-white/25 p-1.5 rounded-sm transition-colors">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M7 7h10v10" />
                      <path d="M7 17 17 7" />
                    </svg>
                  </span>
                </button>
                <p className="text-xs text-gray-500 font-mono tracking-wider pt-1">We respect your privacy. Unsubscribe at any time.</p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
